
import Ugcs from "@/components/Ugcs.vue";
import axios from "axios";
import { Swiper } from "swiper/js/swiper.esm";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { RelUgcBestVO, UgcVO } from "../ugc/vo/ugc.vo";

@Component({
  components: { Ugcs }
})
export default class Talks extends Vue {
  @Prop({ default: true })
  active?: boolean;
  @Prop()
  propbestTalks?: Array<RelUgcBestVO>;
  @Prop()
  ugcCd!: number;
  @Prop()
  categoryCd!: number;

  keyword = "";
  bestTalks: Array<RelUgcBestVO> = [];

  // 베스트 보여줌?
  get showBests() {
    return this.$route.name === "Main" || !this.$isMobile;
  }

  @Watch("active", { immediate: true })
  onUgcActivated() {
    if (this.propbestTalks) {
      this.bestTalks = this.propbestTalks;
    }
    !this.bestTalks.length && this.getBestTalks();
  }

  getBestTalks(): void {
    const params = {
      ugcTypeCd: "047011",
    };
    axios.get(`/ugc/best`, { params: params }).then((r) => {
      this.bestTalks = r.data as Array<RelUgcBestVO>;
      this.$emit("layout-update");
    });
  }

  // 좋아요
  btnLike(item: RelUgcBestVO) {
    const params = { targetCd: item.targetCd, ugcTypeCd: item.ugcTypeCd };
    if (item.liked == 0) {
      axios.post(`/ugc/like`, params).then(() => {
        item.liked = 1;
        item.likeCount++;
        return;
      });
      return;
    }
    axios.delete(`/ugc/like`, { params }).then(() => {
      item.liked = 0;
      item.likeCount--;
      return;
    });
  }
}
